/**
 * @module Identity
 */
/**
 * A function which returns the provided value.
 */
export default function identity(x) {
    return x;
}
